
import React, { Suspense } from 'react';

/**
 * TabContainer
 * Renders the component associated with the active tab ID.
 * Supports lazy loaded components and optional error boundaries.
 * 
 * @param {string} activeTab - The ID of the tab to render
 * @param {Object} tabRegistry - Map of tab IDs to React Components
 * @param {Object} fallback - Loading state (defaults to simple spinner)
 */
const TabContainer = ({ activeTab, tabRegistry, fallback }) => {
    const ActiveComponent = tabRegistry[activeTab];

    if (!ActiveComponent) {
        if (process.env.NODE_ENV === 'development') {
            return (
                <div className="p-8 text-center border-2 border-dashed border-red-300 rounded-lg bg-red-50">
                    <h3 className="text-lg font-medium text-red-800">Tab Not Found</h3>
                    <p className="text-red-600">No component registered for tab ID: <code>{activeTab}</code></p>
                </div>
            );
        }
        return null;
    }

    return (
        <Suspense fallback={fallback || (
            <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
        )}>
            <ActiveComponent />
        </Suspense>
    );
};

export default TabContainer;
